<template>
    <div class="uk-margin-remove">
        <h3 class="uk-h4 uk-margin-small-bottom">
            <div v-if="list_status_message" v-html="list_status_message"></div>
        </h3>
        <div class="uk-grid uk-grid-xsmall uk-visible@s uk-margin-xsmall-bottom" uk-grid>
            <dr-filter-tag
                v-if="selectedDate.value"
                :key="selectedDate.value"
                :type="'date'"
                :filterTagText="selectedDate.value"
            />
            <dr-filter-tag
                v-for="(item, index) in checkedFilter"
                :index="index"
                :key="item.label"
                :type="'checkbox'"
                :filterTag="item.label"
                :filterTagText="item.label | array_key"
            />
            <div v-if="checkedFilter.length > 1 || (checkedFilter.length >= 1 && selectedDate.value)">
                <div class="uk-height-1-1 uk-flex uk-flex-middle uk-margin-small-left">
                    <button class="uk-button uk-button-link uk-link-orange" @click.prevent="removeAllTags">{{ $t("message.clear_all") }}</button>
                </div>
            </div>
        </div>
        <div v-if="eventsList.length && upcomingEventsCounter === 0 && pastEventsCounter === 0" class="uk-margin-xlarge-top">
            <img src="/wp-content/themes/datarobot6/assets/images/no-events-image.svg" alt="No events by selected parameters" loading="lazy">
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import FilterTag from './Filter-tag.vue'
    import {EventBus} from "../../../../templates/events";

    export default {
        name: "ActiveFilter",
        components: {
            'dr-filter-tag': FilterTag
        },
        data () {
            return {
                upcomingCounter: 0,
                pastCounter: 0
            }
        },
        computed: {
            ...mapGetters([
                'checkedFilter',
                'pastEventsCounter',
                'upcomingEventsCounter',
                'selectedDate',
                'eventsList'
            ]),
            list_status_message: function(){
                // Keeping the "upcoming_and_past" option here, just in case 
                // if (this.upcomingEventsCounter >= 0 && this.pastEventsCounter > 0) {
                //     return this.$t('message.upcoming_and_past', { upcomingCount: this.upcomingEventsCounter, pastCount: this.pastEventsCounter });
                // }

                // This renders ONLY the number of upcoming events in the H5 above the list of events 
                if (this.upcomingEventsCounter >= 0 && this.pastEventsCounter > 0) {
                    return this.$t('message.only_upcoming', { upcomingCount: this.upcomingEventsCounter, pastCount: this.pastEventsCounter });
                }

                if (this.upcomingEventsCounter > 0 && this.pastEventsCounter === 0) {
                    return this.$t('message.only_upcoming', { upcomingCount: this.upcomingEventsCounter });
                }

                if (this.eventsList.length && this.upcomingEventsCounter === 0 && this.pastEventsCounter === 0) {
                    return this.$t("message.no_events");
                }

                return false;
            }
        },
        methods: {
            removeAllTags() {
                this.$store.dispatch('removeAllFilters');
                EventBus.$emit('REMOVE_CALENDAR_VALUE');
            }
        },
    }
</script>

<style lang="scss">
.statsCount {
    display: inline-block;
    margin-right: 4px;
    padding: 4px 8px;
    border-radius: 3px;
    background: #a6b0ff;
    min-width: 30px;
    text-align: center;
}
</style>
